<div fxLayout="column" class="comments-post-component full-width full-height">
    <div
        class="comments-post-component__content"
        fxLayout="column"
        [ngStyle]="{
            minHeight:
                !isMobile() && !visualization?.posts?.length
                    ? 'auto'
                    : visualization?.posts?.length
                      ? visualization?.posts?.length * 56 >= 224
                          ? 224
                          : visualization?.posts?.length * 56 + 'px'
                      : null
        }"
        fxFlex
    >
        @if (!visualization?.posts?.length) {
            <span class="badge-posts-alert">
                Nenhum comentário encontrado
            </span>
        }
        <div
            class="comments-post-component__content-posts dsn-scrollbar scroll-light"
            style="position: relative"
            #postsContainer
            fxLayout="column"
            fxFlex
        >
            @for (key of objectKeys(posts); track $index) {
                <div
                    class="comments-post-component__content-posts-date"
                    fxLayout="column"
                >
                    <div
                        fxLayout="row"
                        fxLayoutAlign="center center"
                        style="position: sticky; top: 0px"
                    >
                        <span
                            class="badge-posts-alert"
                            style="
                                border-radius: 8px;
                                background-color: var(
                                    --background-color-primary
                                );
                            "
                            >{{ key }}</span
                        >
                    </div>

                    @for (post of posts[key]; track $index) {
                        <app-chat-message
                            [message]="post.message"
                            [postUserId]="post.userId"
                            [userName]="post.userName"
                            [userId]="contact.props._id"
                            [date]="post.date"
                            [avatar]="post.avatar"
                            [initials]="post.initials"
                            (onDelete)="onDeletePost(post, key)"
                            [showDelete]="true"
                            [isMobileComment]="isMobileComment"
                        ></app-chat-message>
                    }
                </div>
            }
        </div>
    </div>
    <div
        class="comments-post-component__footer {{ !isMobile() && 'mobile' }}"
        fxLayout="column"
    >
        @if (isMobileComment) {
            <div fxLayout="row" fxLayoutAlign="start center" class="gap-16">
                <dsn-button-menu-chips
                    [mainIcon]="
                        getUserLikeType() === 'liked'
                            ? 'fa-solid fa-thumbs-up'
                            : 'fa-regular fa-thumbs-up'
                    "
                    [options]="likeOptions"
                    [size]="'large'"
                    menuPosition="left"
                    (onSelectOption)="onSelectLikeOption($event)"
                ></dsn-button-menu-chips>

                <dsn-button-menu-chips
                    [mainIcon]="
                        getUserLikeType() === 'disliked' ||
                        getUserLikeType() === 'doubts'
                            ? 'fa-solid fa-thumbs-down'
                            : 'fa-regular fa-thumbs-down'
                    "
                    [options]="unlikeOptions"
                    [size]="'large'"
                    menuPosition="left"
                    (onSelectOption)="onSelectLikeOption($event)"
                ></dsn-button-menu-chips>

                @if (getSelectedLikeOption()?.label) {
                    <div class="divider-chips"></div>

                    <dsn-chips
                        [label]="getSelectedLikeOption()?.label"
                        [selected]="hasUserLiked()"
                    ></dsn-chips>
                }
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" class="gap-16">
                <input
                    class="comments-post-component__footer-input {{
                        !isMobile() && 'desktop'
                    }}"
                    type="text"
                    placeholder="Escreva um comentário aqui"
                    fxFlex
                    (keyup.enter)="
                        onSendComment(commentInput.value);
                        commentInput.value = ''
                    "
                    #commentInput
                    [disabled]="disableOnInit"
                />
                <dsn-button-rounded
                    type="primary"
                    icon="fa-solid fa-paper-plane"
                    size="medium"
                    (onClick)="
                        onSendComment(commentInput.value);
                        commentInput.value = ''
                    "
                ></dsn-button-rounded>
            </div>
        } @else {
            <div class="divider-light m-bottom-12"></div>

            <form
                fxLayout="row"
                fxLayoutAlign="start center"
                class="gap-16 full-width"
                [formGroup]="commentForm"
            >
                <dsn-input
                    placeholder="Adicione um comentário"
                    [noValidate]="true"
                    fxFlex
                    type="text"
                    formControlName="comment"
                ></dsn-input>
                <dsn-button-rounded
                    type="primary"
                    icon="fa-solid fa-paper-plane"
                    size="medium"
                    (onClick)="onSendComment(commentForm.value.comment)"
                ></dsn-button-rounded>
            </form>
        }
    </div>
</div>
